export enum AccountSwitchReason {
  LINK = 'link',
  ROLE = 'role',
}

export enum AccountSwitchState {
  CHOICE = 'choice',
  LOADING = 'loading',
  INVALID = 'invalid',
}
